import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Breadcrumb.module.css';
import {
  Badge,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbHeading,
  Dropdown,
  DropdownList,
  DropdownItem,
  MenuToggle
} from '@patternfly/react-core';
import _ from 'lodash';
import { CaretDownIcon } from '@patternfly/react-icons';
// import CaretDownIcon from '@patternfly/react-icons/dist/esm/icons/caret-down-icon';

const BADGE_SIZE = 5;
const FIRST_PART = 2;
const BeaconTowerBreadcrumb = ({ text, items }) => {
  const [isBadgeOpen, setBadgeOpen] = useState(false);
  const toggleBadge = useCallback(() => setBadgeOpen(value => !value), []);
  const onSelect = useCallback(() => {
    setBadgeOpen(value => !value);
  }, []);

  const renderDropdown = useCallback((items) => {
    return (
      <BreadcrumbItem isDropdown key={'dropdown'}>
        <Dropdown
          onSelect={onSelect}
          onOpenChange={(isOpen) => setBadgeOpen(isOpen)}
          toggle={(toggleRef) => (
            <MenuToggle ref={toggleRef} onClick={toggleBadge} isExpanded={isBadgeOpen} variant="plain">
              <Badge isRead screenReaderText="additional items">
                { items.length } { ' ' }
                <span>
                  <CaretDownIcon />
                </span>
              </Badge>
            </MenuToggle>
          )}
          isOpen={isBadgeOpen}
        >
          <DropdownList>{
            items.map((item) => <DropdownItem key={item.location.pathname} ><Link to={item.location}>{ item.displayName }</Link></DropdownItem>)
          }</DropdownList>
        </Dropdown>
      </BreadcrumbItem>
    );
  }, [isBadgeOpen, onSelect, toggleBadge]);


  const badgeRender = useCallback(() => {
    const firstItems = _.slice(items, 0, FIRST_PART);
    const badgeItems = _.slice(items, FIRST_PART, _.size(items) - 1);
    const finalItem = _.last(items);

    return ([
      ..._.map(firstItems, (item, index) => <BreadcrumbItem key={index + '.' + item.location} ><Link to={item.location}>{ item.displayName }</Link></BreadcrumbItem>),
      renderDropdown(badgeItems),
      <BreadcrumbHeading key={'finalItem.' + finalItem.location} to="">{ finalItem.displayName }</BreadcrumbHeading>
    ]
    );
  }, [items, renderDropdown]);

  const renderItems = useCallback(() => {
    if (_.size(items) > BADGE_SIZE) {
      return badgeRender();
    }
    const finalItem = _.last(items);
    const restItems = _.slice(items, 0, _.size(items) - 1);

    return ([
      ..._.map(restItems, (item, index) => <BreadcrumbItem key={index + '.' + item.location}><Link to={item.location ?? item.link}>{ item.displayName }</Link></BreadcrumbItem>),
      <BreadcrumbHeading key={'finalItem.' + finalItem.location} to="">{ finalItem.displayName }</BreadcrumbHeading>
    ]
    );
  }, [badgeRender, items]);

  return (
    !_.isEmpty(items) ?
      <Breadcrumb>
        { renderItems() }
      </Breadcrumb>
      : <h3 className={styles.headerText}>{ text }</h3>
  );

};

export default BeaconTowerBreadcrumb;
